import React from 'react';
import './GetReady.css';

const GetReady = (props) => {
    const state = {
        FourKeys_item: [
            {
                title: 'Innovators:',
                topics: [
                    'Design for sustainability',
                    'GraphQL Federation',
                    'Data + Architecture',
                    'Data Mesh',
                    'Blockchain',
                ],
            },
            {
                title: 'Early adopters:',
                topics: [
                    'Architecture Decision Records',
                    'Design for security',
                    'Design for resilience',
                    'Design for observability',
                    'Micro frontends',
                    'Workflow and decision',
                    'automation platforms',
                ],
            },
            {
                title: 'The architecture of today:',
                topics: [
                    'Modular monolith',
                    'Correctly-built distributed systems',
                    'GraphQL',
                    'Serverless',
                    'Service Mesh',
                ],
            },
            {
                title: 'Well-established best practices:',
                topics: [
                    'Reactive programming',
                    'Event-driven architecture',
                    'Event sourcing',
                    'Eventual consistency',
                    'Microservices',
                    'Domain-driven Design',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <p className='getReady_item--title'>{item.title}</p>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li'>{item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className="getReady_wrap">
            <div className='container getReady'>
                <h3 className='getReady_title'>What's inside</h3>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default GetReady;